import { useEffect, useRef, useState } from 'react';
import { getCoreConfig } from '../config/config';

export const useAppContainerRef = () => {
  const ref = useRef<HTMLElement | null>(null);
  const selector = getCoreConfig().mainLayoutSelector ?? '#main-layout';
  const [, forceUpdate] = useState(0);

  if (!ref.current) {
    ref.current = document.querySelector(selector) as HTMLElement;
  }

  useEffect(() => {
    if (!ref.current) {
      ref.current = document.querySelector(selector) as HTMLElement;
      if (ref.current) {
        forceUpdate((n) => n + 1);
      }
    }
  }, [selector]);

  return ref;
};
